export function getDateLocalConfig(lang) {
    console.log({lang});
    switch (lang) {
        case "cn":
            return {
                placeholder: '请选择日期',
                yearPlaceholder: '请选择年份',
                quarterPlaceholder: '请选择季度',
                monthPlaceholder: '请选择月份',
                weekPlaceholder: '请选择周',
                timePlaceholder: '请选择时间',
                now: '此刻',
                confrim: '确定',
                today: '今天',
                month: '月',
                year: '年',
                weekTitle: ['日', '一', '二', '三', '四', '五', '六'],
                rangePlaceholder: ['开始日期', '结束日期'],
                rangeYearPlaceholder: ['开始年份', '结束年份'],
                rangeMonthPlaceholder: ['开始月份', '结束月份'],
                rangeWeekPlaceholder: ['开始周', '结束周'],
                rangeQuarterPlaceholder: ['开始季度', '结束季度'],
                rangeTimePlaceholder: ['开始时间', '结束时间'],
            }
        case "en":
            return {
                placeholder: 'Please select a date',
                yearPlaceholder: 'Please select a year',
                quarterPlaceholder: 'Please select quarter',
                monthPlaceholder: 'Please select a month',
                weekPlaceholder: 'Please select a week',
                timePlaceholder: 'Please select a time',
                now: 'Now',
                confrim: 'OK',
                today: 'Today',
                month: 'Month',
                year: 'Year',
                weekTitle: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                rangePlaceholder: ['Start Date', ' End Date'],
                rangeYearPlaceholder: ['Start Year ', ' End Year'],
                rangeMonthPlaceholder: ['Start Month ', ' End Month'],
                rangeWeekPlaceholder: ['Start Week ', ' End Week '],
                rangeQuarterPlaceholder: ['Start Quarter ', ' End Quarter'],
                rangeTimePlaceholder: ['Start time ', ' End time'],
            }
    }
}